import { CrmShell } from "@/components/crm/crm-shell";
import { CrmGrid } from "@/components/crm/crm-grid";

/** Leads (CRM): Dynamics-style views; each lead runs the New → Qualify → Assign → Sales accept process. */
export default function Leads() {
  return <CrmShell currentPage="/leads">{(ctx) => <CrmGrid entity="lead" ctx={ctx} />}</CrmShell>;
}
